import { appointmentImageCopy } from '../data/appointmentImageCopy.js';
import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';
import { sourceRevision } from './translationAssurance.js';

// Sharing question images (rather than PDFs) is another patient-facing
// translation surface whose locale tables predate the canonical i18next JSON.
export function buildAppointmentImageTranslationRows(locale) {
  const english = appointmentImageCopy('en');
  const current = appointmentImageCopy(locale);
  return Object.entries(english).map(([key, sourceText]) => {
    const id = 'appointmentImage:' + key;
    return {
      id, namespace: 'appointmentImage', path: key, contentArea: 'core_ui',
      sourceText, sourceRevision: sourceRevision(id, sourceText),
      originalText: current[key] || '',
      provenance: professionalTranslationFor(locale, 'appointmentImage', key)
        ? 'professionally approved correction' : 'legacy appointment image translation',
      publicationTarget: 'locale',
    };
  });
}
